var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.layout,_vm._b({tag:"component"},'component',_vm.templateProps,false),[(!_vm.auth0Loading)?_c('router-view',{attrs:{"layout":_vm.layout},on:{"update:layout":function($event){_vm.layout=$event},"update:templateProps":_vm.handleUpdateProps}}):_vm._e(),_c('Notification')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }